import { DispatchWithoutAction, useReducer } from 'react';

/**
 * This hook helps us to force-update the component where it's rendered
 * by incrementing the reducer state. The reducer state value is not needed in this case.
 */
export const useForceUpdate = (): DispatchWithoutAction =>
  useReducer((v) => v + 1, 0)[1];
